module.exports = __webpack_public_path__ + "img/promo-color.65c7e234.png";